module.exports = __webpack_public_path__ + "img/04_kii_17.91b466e0.jpg";